module.exports = __webpack_public_path__ + "img/5.0138c332.png";